
import Upload from './upload.vue'
import {FTYPES} from 'consts/ftypes'

export default {
  components: {Upload},
  props: {
    filesStore: {type: Object, required: true}
  },
  emits: ['remove', 'retry'], 
  computed: {
    files() {
      return this.filesStore.files.toReversed().filter(f => !f.deleting)
    },
    uploads() {
      return this.filesStore.uploads
    },
    accept(){
      const type = this.filesStore.type
      return FTYPES[type].exts.join(',')
    }
  },
  methods: {
    uploadFile() {
      this.$refs.file.click()
    },
    async onUpload() {
      const file_input = this.$refs.file
      await this.filesStore.upload(file_input.files[0])
    },
    async retryUpload(id) {
      await this.uploads.find(upload => upload.id === id).start()
    },
    async removeUpload(id) {
      await this.filesStore.deleteUpload(id)
    },
    async removeFile(id) {
      await this.filesStore.delete(id)
    }
  }
}
